<template>
  <div class="row Wrap">
    <div class="containerspa">
      <div class="col-xs-12 col-sm-12 col-md-12 page-right">
        <keep-alive>
          <router-view/>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {}
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.page-right{
  margin-top: 2%;
  margin-bottom: 3%;
  min-height: 500px;
}
@media (min-width: 320px) and (max-width: 767px){
  .page-right{
    min-height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/indexSpa/main.vue